import PropTypes from 'prop-types';

function ActionButton({ label, onClick, disabled, children }) {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className="flex items-center gap-2 rounded-full bg-gray-600/50 px-4 py-2 text-gray-200 shadow-md ring-1 ring-gray-200/10 transition-opacity disabled:cursor-not-allowed disabled:opacity-40"
		>
			<span className="flex h-[2.2vh] w-[2.2vh] items-center justify-center">
				{children}
			</span>
			<span className="text-[1.8vh] font-semibold tracking-[0.08em] uppercase">
				{label}
			</span>
		</button>
	);
}

ActionButton.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	children: PropTypes.node,
};

function TopActionRow(props) {
	return (
		<div className="flex w-full justify-end gap-3 px-5 pt-4 text-gray-300">
			<ActionButton
				label="Random"
				onClick={props.onRandomizeBtnClicked}
				disabled={props.areActionsDisabled}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-full w-full drop-shadow"
					fill="currentColor"
					viewBox="0 0 16 16"
				>
					<path
						fillRule="evenodd"
						d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z"
					/>
					<path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z" />
				</svg>
			</ActionButton>
			<ActionButton
				label="Skip"
				onClick={props.onSkipWord}
				disabled={props.areActionsDisabled || props.canSkipWord === false}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-full w-full drop-shadow"
					fill="currentColor"
					viewBox="0 0 16 16"
				>
					<path d="M3.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm8.354 4.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 1 1-.708-.708L10.293 8.5H5.5a.5.5 0 0 1 0-1h4.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3z" />
				</svg>
			</ActionButton>
		</div>
	);
}

TopActionRow.propTypes = {
	areActionsDisabled: PropTypes.bool,
	canSkipWord: PropTypes.bool,
	onRandomizeBtnClicked: PropTypes.func,
	onSkipWord: PropTypes.func,
};

export default TopActionRow;